import { render, staticRenderFns } from "./TagInfo.vue?vue&type=template&id=23d0cf5a&scoped=true&"
import script from "./TagInfo.vue?vue&type=script&lang=js&"
export * from "./TagInfo.vue?vue&type=script&lang=js&"
import style0 from "./TagInfo.vue?vue&type=style&index=0&id=23d0cf5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0cf5a",
  null
  
)

export default component.exports